"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var babylonjs_1 = require("babylonjs");
var vector_functions_1 = require("./util/vector-functions");
var const_1 = require("./util/const");
var vf_scene_cache_1 = require("./util/vf-scene-cache");
var vf_mesh_factory_1 = require("./util/vf-mesh-factory");
var vf_config_manager_1 = require("./util/vf-config-manager");
var logger_1 = require("./util/logger");
var VFXRPlacementState;
(function (VFXRPlacementState) {
    VFXRPlacementState[VFXRPlacementState["PlacementUnavailable"] = 0] = "PlacementUnavailable";
    VFXRPlacementState[VFXRPlacementState["PlacementAvailable"] = 1] = "PlacementAvailable";
    VFXRPlacementState[VFXRPlacementState["ModelPlaced"] = 2] = "ModelPlaced";
})(VFXRPlacementState || (VFXRPlacementState = {}));
var VFXRManager = (function () {
    function VFXRManager(scene) {
        this.scene = scene;
        this.initialized = false;
        this.sceneCache = new vf_scene_cache_1.default(scene);
    }
    VFXRManager.prototype.isARAvailable = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        _a = navigator.xr;
                        if (!_a) return [3, 2];
                        return [4, navigator.xr.isSessionSupported("immersive-ar")];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2: return [2, _a];
                    case 3:
                        error_1 = _b.sent();
                        logger_1.default.warn(error_1);
                        return [2, false];
                    case 4: return [2];
                }
            });
        });
    };
    VFXRManager.prototype.isARActive = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.xrHelper.state];
                    case 1: return [2, (_a.sent()) === babylonjs_1.WebXRState.IN_XR];
                }
            });
        });
    };
    VFXRManager.prototype.enterAR = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.isARAvailable];
                    case 1:
                        if (!(_a.sent())) {
                            return [2];
                        }
                        if (!!this.initialized) return [3, 3];
                        return [4, this.initialize()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [4, this.isARActive()];
                    case 4:
                        if (!!(_a.sent())) return [3, 8];
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4, this.xrHelper.enterXRAsync("immersive-ar", "local-floor", this.xrHelper.sessionManager.getWebXRRenderTarget())];
                    case 6:
                        _a.sent();
                        return [3, 8];
                    case 7:
                        error_2 = _a.sent();
                        logger_1.default.warn("user did not grant permission to start ar session");
                        return [3, 8];
                    case 8: return [2];
                }
            });
        });
    };
    VFXRManager.prototype.initialize = function () {
        return __awaiter(this, void 0, void 0, function () {
            var xrHelper;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, babylonjs_1.WebXRExperienceHelper.CreateAsync(this.scene)];
                    case 1:
                        xrHelper = _a.sent();
                        if (xrHelper) {
                            this.xrHelper = xrHelper;
                            xrHelper.featuresManager.enableFeature(babylonjs_1.WebXRHitTestLegacy.Name, "latest");
                            xrHelper.sessionManager.onXRSessionInit.add(this.onXRSessionInit.bind(this));
                            xrHelper.sessionManager.onXRFrameObservable.add(this.onXRFrame.bind(this));
                            xrHelper.sessionManager.onXRSessionEnded.add(this.onXRSessionEnd.bind(this));
                            xrHelper.onInitialXRPoseSetObservable.add(function (xrCamera) {
                                xrCamera.position.y = 0;
                                xrCamera.position.x = 0;
                                xrCamera.position.z = 0;
                                xrCamera.setTarget(new babylonjs_1.Vector3(0, 0, -1));
                            });
                        }
                        this.initialized = true;
                        return [2];
                }
            });
        });
    };
    VFXRManager.prototype.onXRSessionInit = function (session) {
        return __awaiter(this, void 0, void 0, function () {
            var referenceSpace;
            return __generator(this, function (_a) {
                this.scene.onARInit();
                this.sceneCache.store();
                this.scene.model.scaleToSize(const_1.default.AR_SCALE);
                this.placementIndicator = vf_mesh_factory_1.default.CreateARPlacementIndicator("vfPlacementIndicator", this.scene);
                if (vf_config_manager_1.default.GetConfig().enableShadows) {
                    this.groundPlane = vf_mesh_factory_1.default.CreateShadowPlane("vfARShadowPlane", const_1.default.AR_SHADOW_PLANE_SIZE, this.scene);
                }
                else {
                    this.groundPlane = vf_mesh_factory_1.default.CreateDropShadow("vfARDropShadow", const_1.default.AR_DROP_SHADOW_SIZE, this.scene);
                }
                this.groundPlane.setParent(this.scene.model.getRoot());
                this.setPlacementState(VFXRPlacementState.PlacementUnavailable);
                referenceSpace = session.requestReferenceSpace("local-floor");
                session.addEventListener("select", this.onXRSelect.bind(this));
                return [2];
            });
        });
    };
    VFXRManager.prototype.onXRFrame = function (frame) {
        var _this = this;
        var session = frame.session;
        var pose = frame.getViewerPose(this.referenceSpace);
        if (pose && !(this.placementState === VFXRPlacementState.ModelPlaced)) {
            var ray = new XRRay(frame.getViewerPose(this.referenceSpace).transform);
            babylonjs_1.WebXRHitTestLegacy.XRHitTestWithRay(session, ray, this.referenceSpace).then(function (results) {
                if (results.length > 0) {
                    _this.setMeshPositionToHitMatrix(_this.placementIndicator, babylonjs_1.Matrix.FromArray(results[0].hitMatrix));
                    _this.setPlacementState(VFXRPlacementState.PlacementAvailable);
                }
                else {
                    _this.setPlacementState(VFXRPlacementState.PlacementUnavailable);
                }
            });
        }
    };
    VFXRManager.prototype.onXRSessionEnd = function (session) {
        this.sceneCache.restore();
        this.placementIndicator.dispose();
        this.groundPlane.dispose();
        this.scene.onARExit();
    };
    VFXRManager.prototype.onXRSelect = function (event) {
        if (this.placementState === VFXRPlacementState.PlacementAvailable) {
            this.scene.model.getRoot().setAbsolutePosition(this.placementIndicator.getAbsolutePosition());
            vector_functions_1.alignOnYAxis(this.scene.model.getRoot(), this.xrHelper.camera.position);
            this.setPlacementState(VFXRPlacementState.ModelPlaced);
        }
        else if (this.placementState === VFXRPlacementState.ModelPlaced) {
            var tapTimestamp = new Date().getTime();
            if (this.lastTapTimestamp &&
                tapTimestamp - this.lastTapTimestamp < const_1.default.AR_DOUBLE_TAP_RESET_THRESHOLD) {
                this.setPlacementState(VFXRPlacementState.PlacementUnavailable);
            }
            this.lastTapTimestamp = tapTimestamp;
        }
    };
    VFXRManager.prototype.setPlacementState = function (state) {
        this.placementState = state;
        switch (state) {
            case VFXRPlacementState.PlacementUnavailable:
                this.placementIndicator.setEnabled(false);
                this.scene.model.getRoot().setEnabled(false);
                break;
            case VFXRPlacementState.PlacementAvailable:
                this.placementIndicator.setEnabled(true);
                this.scene.model.getRoot().setEnabled(false);
                break;
            case VFXRPlacementState.ModelPlaced:
                this.placementIndicator.setEnabled(false);
                this.scene.model.getRoot().setEnabled(true);
        }
    };
    VFXRManager.prototype.setMeshPositionToHitMatrix = function (mesh, hitMatrix) {
        if (this.scene.useRightHandedSystem) {
            hitMatrix.toggleModelMatrixHandInPlace();
        }
        var pos = hitMatrix.getTranslation();
        this.scene.setTransformMatrix(this.scene.getViewMatrix(), hitMatrix);
        pos = pos.multiplyByFloats(-1, 1, 1);
        setTimeout(function () {
            mesh.setAbsolutePosition(pos);
            mesh.computeWorldMatrix(true);
        });
    };
    return VFXRManager;
}());
exports.default = VFXRManager;
